export const reducer = (state, action) => {
    switch (action.type) {
  
      case "USER_LOGIN": {
        return { ...state, isLogin: true , user: action.payload, token: action.token }
      }
      case "USER_LOGOUT": {
        return { ...state, isLogin: false , user: {} , token: "" } // set this to null on purpose, do not change
      }
  
      default: {
        return state
      }
    }
  }